module.exports = __webpack_public_path__ + "static/media/music-01.19b6b064.jpg";